import { baseApi } from "./baseApi";
import { parseBankAccounts, parseBankTransactions } from "../parsers/finfactorBank.parser";

export const finfactorBankApiSlice = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getFinfactorBankAccounts: builder.query({
            query: () => ({
                url: "api/account-aggregator/bank-account",
                method: "GET"
            }),
            transformResponse: (response) => {
                const { result } = response || {};
                return parseBankAccounts(result);
            },
            providesTags: ["BankingAccounts"]
        }),

        getFinfactorBankTransactions: builder.query({
            query: ({ id, type, page = 1, limit = 10, minAmount, maxAmount, fromDate, toDate }) => {
                const params = new URLSearchParams();
                if (type && type !== "all") params.append("type", type.toUpperCase());
                if (page) params.append("page", page);
                if (limit) params.append("limit", limit);
                if (minAmount) params.append("minAmount", minAmount);
                if (maxAmount) params.append("maxAmount", maxAmount);
                if (fromDate) params.append("fromDate", fromDate);
                if (toDate) params.append("toDate", toDate);

                const queryString = params.toString();
                return {
                    url: `api/account-aggregator/bank-account/${id}${queryString ? `?${queryString}` : ""}`,
                    method: "GET"
                };
            },
            transformResponse: (response) => {
                const { result } = response || {};
                return parseBankTransactions(result);
            },
            providesTags: ["BankingAccounts"]
        }),
    })
});

export const {
    useGetFinfactorBankAccountsQuery,
    useLazyGetFinfactorBankAccountsQuery,
    useGetFinfactorBankTransactionsQuery,
} = finfactorBankApiSlice;
